// src/Layout/index.js
import React, { Component } from 'react';
import { Container, Spinner, Modal, ModalBody, Button } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Global } from '~/App';
import API from '~/API';
import { Switch } from 'react-router';
import { ChatProvider } from '~/Chat/ChatContext';
import { AsistenteVirtual } from '~/Chat/AsistenteVirtual';
import ErrorBoundary from '~/Chat/ErrorBoundary';

export class Layout extends Component {
  static displayName = Layout.name;

  constructor(){
    super();
    this.state={
      Usuario:null,
      cargando:false,
      Servicios:[],
      cargandoServicios:false,
      wixLocation:null,
      abrirPoliticas:false
    }
    this.setUsuario = this.setUsuario.bind(this);
    Global.setUsuario = this.setUsuario;
    this.setServicios = this.setServicios.bind(this);
    Global.setServicios = this.setServicios;
    this.setCargandoServicios = this.setCargandoServicios.bind(this);
    Global.setCargandoServicios = this.setCargandoServicios;
    Global.cargarUsuarioSesion = this.cargarUsuarioSesion;
  }

  cargarUsuarioSesion = () => {
    if (!API.Cookie) return;
    this.setState({ cargando: true });
    API.Call("Home/GetUser")
      .then(response => {
        if (response.ok) {
          this.setUsuario(response.user);
          this.setState({ cargando: false, cargandoServicios: true });
          API.Call("Administra/Servicio/Listado").then(Servicios => {
            this.setState({ Servicios, cargandoServicios: false });
          }).catch(() => this.setState({ cargandoServicios: false }));
        } else {
          this.setState({ cargando: false });
        }
      })
      .catch(() => this.setState({ cargando: false }));
  };

  componentWillMount(){
    try{
      var _this = this;
      window.onmessage = e => {
        if (!e || !e.data) return;
        if (typeof e.data.wixLocation === 'string' && e.data.wixLocation) {
          const matchAuth = e.data.wixLocation.match(/authToken=([^&#]*)/);
          if (matchAuth && matchAuth[1] && !API.Cookie) {
            API.SetHeaderBearer(matchAuth[1]).then(() => {
              _this.cargarUsuarioSesion();
            });
          }
          _this.setState({ wixLocation: e.data.wixLocation });
        }
        const extraSearch = typeof e.data.search === 'string' ? e.data.search : (typeof e.data.query === 'string' ? e.data.query : null);
        if (extraSearch) {
          _this.setState({ wixLocation: extraSearch });
        }
        if (e.data.authToken && !API.Cookie) {
          API.SetHeaderBearer(e.data.authToken).then(() => {
            _this.cargarUsuarioSesion();
          });
        }
      };
      window.parent.postMessage({ listo: true }, '*');
    }catch{}
    if(API.Cookie){
      this.cargarUsuarioSesion();
    }
  }
  setCargandoServicios(){
    Global.cargandoServicios = true;
    this.setState({cargandoServicios:true})
  }
  setServicios(Servicios){
    Global.Servicios = Servicios;
    Global.cargandoServicios = false;
    this.setState({cargandoServicios:false,Servicios});
  }


  setUsuario(Usuario){
    Global.Usuario = Usuario;
    this.setState({Usuario});
  }

  render () {
    const empresaActual = Global.empresas.find(e => e.key === Global.empresaDefecto);
    
    const isCompact = Global.isModoCompact && Global.isModoCompact();
    const chatHabilitado = !isCompact && empresaActual?.otros?.Chat && !document.getElementById('Chat-Clientes'); 

    return (
      this.state.cargando ? 
        <div className="d-flex flex-column justify-content-center align-items-center py-5 my-5 text-center" style={{ minHeight: '300px' }}>
            <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
            <div className="mt-3 text-muted font-weight-bold">Cargando sucursal virtual...</div>
        </div> :  
      <div className={isCompact ? "portal-compacto-root" : ""}>
        {!isCompact && <NavMenu Usuario = {this.state.Usuario} Servicios = {this.state.Servicios}/>}
        <Container fluid={!isCompact} className={isCompact ? "portal-compacto-wrapper p-0" : ""}>
          {isCompact && window.location.hash && window.location.hash !== "#/" && window.location.hash !== "#" && (
            <div className="portal-compacto-container mb-2 text-left">
              <a href="#/" className="btn btn-sm btn-link text-muted pl-0">
                <i className="fa fa-arrow-left mr-1" /> Volver al inicio
              </a>
            </div>
          )}
          <Switch>
          {
          React.Children.map(this.props.children, child =>{
            if(child) return React.cloneElement(child, { passedProps: {Servicios: this.state.Servicios, Usuario: this.state.Usuario, cargandoServicios:this.state.cargandoServicios, wixLocation:this.state.wixLocation }}) // para forzar la actualización
          }
          )
          }
          </Switch>
        </Container>
        {chatHabilitado ? <ErrorBoundary><ChatProvider><AsistenteVirtual /></ChatProvider></ErrorBoundary> : null }
        {!isCompact && Global.politicas && (
          <footer className="text-center py-3 text-muted small border-top mt-4">
            <Button color="link" className="p-0 text-muted small align-baseline" onClick={() => this.setState({ abrirPoliticas: true })}>
              Política de Privacidad
            </Button>
          </footer>
        )}
        {Global.politicas && (
          <Modal size="lg" className="TerminosCondiciones" wrapClassName="asyntec-portal-clientes" isOpen={this.state.abrirPoliticas} toggle={() => this.setState({ abrirPoliticas: !this.state.abrirPoliticas })} scrollable>
            <ModalBody>
              <div dangerouslySetInnerHTML={{ __html: Global.politicas }} />
              <Button color="primary" className="mt-3 float-right" onClick={() => this.setState({ abrirPoliticas: false })}>Cerrar</Button>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}